import {mapGetters, mapActions, mapMutations} from 'vuex'
import ContactMixin from 'js/mixins/contact-modal-mixin'
import HelperVideoModal from 'js/components/modals/helper-video-modal'
import AccessiblityModal from 'js/components/modals/accessibility'
import languageModal from 'js/components/language-modal'
import template from './index.pug'

export default Vue.extend({
  name: 'default-layout',
  template: template(),
  components: {
    HelperVideoModal,
    languageModal,
    AccessiblityModal
  },
  mixins: [ContactMixin],

  computed: {
    ...mapGetters('appConfig', ['hasBasicData']),
    ...mapGetters([
      'showLanguageModal',
      'municipality/availableMunicipalities',
      'getHelperVideoState',
      'getAccessibilityModalState'
    ]),

    notifications: {
      get() {
        return this.$store.state.notifications
      },

      set(value) {
        this.$store.commit('UPDATE_NOTIFICATIONS', value)
      }
    },

    mainClass() {
      if (_.includes(this.$route.name, 'municipality')) return 'ns-layout__content__map'
      return ''
    },

    layoutClass() {
      if (_.includes(this.$route.name, 'municipality')) return 'municipality-layout'
      return ''
    }
  },

  watch: {
    async '$route.params.municipality'() {
      await this.loadBasicData()
    },

    async '$route.query.openContactModal'(newValue) {
      this.showContactModal = newValue === 'true'
    },

    async '$route.query.openAccessibilityModal'(newValue) {
      this.showAccessibilityModal = newValue === 'true'
    }
  },

  async created() {
    this.initializeAccessibilityOptions()
    if(!this.hasBasicData) await this.loadBasicData()
  },

  // TODO: mover esta lógica a otro sitio mejor
  methods: {
    ...mapActions('appConfig', ['loadBasicData']),
    ...mapActions('administrativeArea', [
      'loadAdministrativeAreaFromMunicipality',
      'loadAdministrativeArea',
    ]),
    ...mapActions('municipality', ['loadAvailableMunicipalities']),
    ...mapActions([
      'hideHelperVideo', 
      'initializeAccessibilityOptions',
      'closeAccessibilityModal'
    ]),

    closeVideoModal(){
      this.hideHelperVideo()
      this.customAccesibilityTabs.setup(this.$options.name)
    }
    
  }
})
